export function getCookieByName(name: string) {
  const cookies = document.cookie.split('; ');

  for (const cookie of cookies) {
    const [key, ...rest] = cookie.split('=');
    if (key === name) {
      return decodeURIComponent(rest.join('='));
    }
  }

  return undefined;
}
